<template>
    <div class="fs_dropzone relative min-h-[28px]">
        <input ref="focusCatcher" class="opacity-0 absolute"
               name="notASearchField"
               placeholder="NotASearchField"
               autocomplete="off"
               style="width: 1px; height:1px; margin:0px; padding:0px; overflow: hidden;"
               @keydown.enter="(e) => {editable = true; editName(false)}"
               @keydown.space="(e) => {go()}"
               @keydown.up="(e) => {$emit('previousNode',e)}"
               @keydown.down="(e) => {$emit('nextNode',e)}"
               @keydown.left="(e) => {$emit('previousNode',e)}"
               @keydown.right="(e) => {$emit('nextNode',e)}"
        >
        <vue2-dropzone :ref="'myDropzone-'+directory.id"
                       :options="dropzoneOptions"
                       :id="'dz'+directory.id"
                       :duplicateCheck="false"
                       :includeStyling="false"
                       :useCustomSlot="true"
                       v-on:vdropzone-drag-enter="dragged"
                       v-on:vdropzone-drag-over="dragged"
                       v-on:vdropzone-drag-leave="draggedOut"
                       v-on:vdropzone-success="success"
                       v-on:vdropzone-complete="draggedOut"
                       :class="innerClass + ' dir'"
        >
            <div
                class="flex m-0 select-none items-center border-border-dashed border-transparent cursor-pointer relative">
                <div class="relative shrink-0" :class="prefs.size==='large'?'w-16':'w-8'">
                    <svg xmlns="http://www.w3.org/2000/svg" class="ml-0.5" :width="prefs.size==='large'?'48px':'24px'"
                         :height="prefs.size==='large'?'48px':'24px'" version="1.0"
                         xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48">
                        <defs id="defs3">
                            <radialGradient id="radialGradient6719" xlink:href="#linearGradient5060"
                                            gradientUnits="userSpaceOnUse" cy="486.65" cx="605.71"
                                            gradientTransform="matrix(-2.7744 0 0 1.9697 112.76 -872.89)" r="117.14"/>
                            <linearGradient id="linearGradient5060">
                                <stop id="stop5062" offset="0"/>
                                <stop id="stop5064" stop-opacity="0" offset="1"/>
                            </linearGradient>
                            <radialGradient id="radialGradient6717" xlink:href="#linearGradient5060"
                                            gradientUnits="userSpaceOnUse" cy="486.65" cx="605.71"
                                            gradientTransform="matrix(2.7744 0 0 1.9697 -1891.6 -872.89)" r="117.14"/>
                            <linearGradient id="linearGradient6715" y2="609.51" gradientUnits="userSpaceOnUse"
                                            x2="302.86" gradientTransform="matrix(2.7744 0 0 1.9697 -1892.2 -872.89)"
                                            y1="366.65" x1="302.86">
                                <stop id="stop5050" stop-opacity="0" offset="0"/>
                                <stop id="stop5056" offset=".5"/>
                                <stop id="stop5052" stop-opacity="0" offset="1"/>
                            </linearGradient>
                            <radialGradient id="radialGradient238" gradientUnits="userSpaceOnUse" cy="37.518"
                                            cx="20.706"
                                            gradientTransform="matrix(1.055 -.027345 .17770 1.1909 -3.5722 -7.1253)"
                                            r="30.905">
                                <stop id="stop1790" stop-color="#202020" offset="0"/>
                                <stop id="stop1791" stop-color="#b9b9b9" offset="1"/>
                            </radialGradient>
                            <linearGradient id="linearGradient491" y2="66.834" gradientUnits="userSpaceOnUse"
                                            x2="9.8981" gradientTransform="matrix(1.5168 0 0 .70898 -.87957 -1.3182)"
                                            y1="13.773" x1="6.2298">
                                <stop id="stop3984" stop-color="#fff" stop-opacity=".87629" offset="0"/>
                                <stop id="stop3985" stop-color="#fffffe" stop-opacity="0" offset="1"/>
                            </linearGradient>
                            <linearGradient id="linearGradient322" y2="46.689" gradientUnits="userSpaceOnUse"
                                            x2="12.854" gradientTransform="matrix(1.3175 0 0 .81626 -.87957 -1.3182)"
                                            y1="32.567" x1="13.036">
                                <stop id="stop320" stop-color="#fff" offset="0"/>
                                <stop id="stop321" stop-color="#fff" stop-opacity="0" offset="1"/>
                            </linearGradient>
                            <linearGradient id="linearGradient3104" y2="6.1803" gradientUnits="userSpaceOnUse"
                                            x2="15.515" y1="31.368" x1="18.113">
                                <stop id="stop3098" stop-color="#424242" offset="0"/>
                                <stop id="stop3100" stop-color="#777" offset="1"/>
                            </linearGradient>
                            <linearGradient id="linearGradient9772" y2="32.05" gradientUnits="userSpaceOnUse"
                                            x2="22.065" y1="36.988" x1="22.176">
                                <stop id="stop9768" stop-color="#6194cb" offset="0"/>
                                <stop id="stop9770" stop-color="#729fcf" offset="1"/>
                            </linearGradient>
                        </defs>
                        <g id="layer1">
                            <g id="g6707" transform="matrix(.022624 0 0 .020868 43.383 36.37)">
                                <rect id="rect6709" opacity=".40206" height="478.36" width="1339.6" y="-150.7"
                                      x="-1559.3" fill="url(#linearGradient6715)"/>
                                <path id="path6711" opacity=".40206"
                                      d="m-219.62-150.68v478.33c142.88 0.9 345.4-107.17 345.4-239.2 0-132.02-159.44-239.13-345.4-239.13z"
                                      fill="url(#radialGradient6717)"/>
                                <path id="path6713" opacity=".40206"
                                      d="m-1559.3-150.68v478.33c-142.8 0.9-345.4-107.17-345.4-239.2 0-132.02 159.5-239.13 345.4-239.13z"
                                      fill="url(#radialGradient6719)"/>
                            </g>
                            <path id="path216" stroke-linejoin="round"
                                  d="m4.5218 38.687c0.0218 0.417 0.4599 0.833 0.8762 0.833h31.327c0.416 0 0.811-0.416 0.789-0.833l-0.936-27.226c-0.022-0.417-0.46-0.833-0.877-0.833h-13.27c-0.486 0-1.235-0.316-1.402-1.1066l-0.612-2.893c-0.155-0.7357-0.882-1.0379-1.298-1.0379h-14.779c-0.4162 0-0.8107 0.4163-0.7889 0.8326l0.9707 32.264z"
                                  stroke="url(#linearGradient3104)" stroke-linecap="round"
                                  fill="url(#radialGradient238)"/>
                            <path id="path9788" opacity=".11364" stroke-linejoin="round" d="m5.2266 22.562h30.265"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9784" opacity=".11364" stroke-linejoin="round" d="m5.0422 18.562h30.447"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9778" opacity=".11364" stroke-linejoin="round" d="m4.9807 12.562h30.507"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9798" opacity=".11364" stroke-linejoin="round" d="m5.3862 32.562h30.109"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9800" opacity=".11364" stroke-linejoin="round" d="m5.5091 34.562h29.988"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9782" opacity=".11364" stroke-linejoin="round" d="m5.0422 16.562h30.447"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9780" opacity=".11364" stroke-linejoin="round" d="m5.0114 14.562h30.478"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9776" opacity=".11364" stroke-linejoin="round" d="m4.9221 10.562h15.281"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9774" opacity=".11364" stroke-linejoin="round" d="m4.8738 8.5625h14.783"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9794" opacity=".11364" stroke-linejoin="round" d="m5.3247 28.562h30.169"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9792" opacity=".11364" stroke-linejoin="round" d="m5.2881 26.562h30.205"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9790" opacity=".11364" stroke-linejoin="round" d="m5.2266 24.562h30.265"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9786" opacity=".11364" stroke-linejoin="round" d="m5.1959 20.562h30.296"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9796" opacity=".11364" stroke-linejoin="round" d="m5.3247 30.562h30.169"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path9802" opacity=".11364" stroke-linejoin="round" d="m5.5091 36.562h29.988"
                                  stroke="#000" stroke-linecap="round" fill="#729fcf"/>
                            <path id="path219" opacity=".45143"
                                  d="m6.0683 38.864c0.0164 0.312-0.1809 0.52-0.4985 0.416-0.3177-0.104-0.5368-0.312-0.5531-0.624l-0.9477-32.065c-0.0164-0.3118 0.1651-0.5004 0.4774-0.5004l14.422-0.0477c0.313 0 0.932 0.3005 1.133 1.3222l0.574 2.8159c-0.427-0.4656-0.419-0.48-0.638-1.1571l-0.406-1.2592c-0.219-0.7276-0.698-0.8319-1.01-0.8319h-12.888c-0.3122 0-0.5095 0.2082-0.4931 0.5204l0.938 31.515-0.1096-0.104z"
                                  display="block" fill="url(#linearGradient491)"/>
                            <g id="g220" fill-opacity=".75706"
                               transform="matrix(1.0408 0 .054493 1.0408 -8.6702 2.6706)" fill="#fff">
                                <path id="path221" fill-opacity=".50847" fill="#fff"
                                      d="m42.417 8.5152c0.005-0.0971-0.128-0.247-0.235-0.247l-13.031-0.0021s0.911 0.5879 2.201 0.5962l11.054 0.071c0.011-0.2117 0.003-0.256 0.011-0.4181z"/>
                            </g>
                            <path id="path233" stroke-linejoin="round"
                                  d="m39.784 39.511c1.143-0.044 1.963-1.097 2.047-2.321 0.791-11.549 1.659-21.232 1.659-21.232 0.072-0.248-0.168-0.495-0.48-0.495h-34.371c-0.0004 0-1.8507 21.867-1.8507 21.867-0.1145 0.982-0.466 1.804-1.5498 2.183l34.546-0.002z"
                                  display="block" stroke="#3465a4" fill="url(#linearGradient9772)"/>
                            <path id="path304" opacity=".46591"
                                  d="m9.6202 16.464l32.791 0.065-1.574 20.002c-0.084 1.071-0.45 1.428-1.872 1.428-1.872 0-28.678-0.032-31.395-0.032 0.2335-0.321 0.3337-0.989 0.335-1.005l1.7152-20.458z"
                                  stroke="url(#linearGradient322)" stroke-linecap="round" stroke-width="1px"
                                  fill="none"/>
                            <path id="path323"
                                  d="m9.6202 16.223l-1.1666 15.643s8.2964-4.148 18.666-4.148 15.555-11.495 15.555-11.495h-33.055z"
                                  fill-opacity=".089286" fill-rule="evenodd" fill="#fff"/>
                        </g>
                        <svg v-if="directory.system" xmlns="http://www.w3.org/2000/svg" viewBox="-29 -35 100 100">
                            <path d="M34 23h-2v-4c0-3.9-3.1-7-7-7s-7 3.1-7 7v4h-2v-4c0-5 4-9 9-9s9 4 9 9v4z"/>
                            <path
                                d="M33 40H17c-1.7 0-3-1.3-3-3V25c0-1.7 1.3-3 3-3h16c1.7 0 3 1.3 3 3v12c0 1.7-1.3 3-3 3zM17 24c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h16c.6 0 1-.4 1-1V25c0-.6-.4-1-1-1H17z"/>
                            <circle cx="25" cy="28" r="2"/>
                            <path d="M25.5 28h-1l-1 6h3z"/>
                        </svg>
                    </svg>
                </div>
                <div class="ml-2 min-w-0 flex-1" :class="prefs.size==='small'?'pt-1 flex align-items-center pr-1':''">
                    <div class="flex-1 overflow-hidden">
                        <autoresizable-input v-if="editingName" :min="120" :limit-max-to-parent="true">
                            <page-cell name="notASearchField" v-model="newName" @keydown="keyDown" @blur="updateName"
                                       ref="item-name"
                                       placeholder="Directory..."
                                       class="inline-block overflow-hidden border-none shadow-none ring-0 outline-none bg-transparent text-sm p-0 mt-0 mx-0"
                                       :class="prefs.size==='small'?' mb-1 mt-0.5 ml-0.5':' mb-0'">
                            </page-cell>
                        </autoresizable-input>
                        <div @mouseup="mousedUp" @dblclick="go" @click="editName" v-else
                             v-text="directory.name"
                             class="inline-block max-w-full overflow-x-hidden overflow-y-hidden text-ellipsis whitespace-nowrap text-sm p-0 mt-0.5 mx-0"
                             :class="(prefs.size==='small'?'ml-0.5 mb-1 ':' mb-0 ') + (this.selected.includes(this.directory)?'cursor-text':'')"
                        >
                        </div>
                    </div>
                    <template v-if="prefs.size==='large'">
                    <span
                        v-if="directory.createdAt"
                        class="block overflow-hidden whitespace-nowrap text-xs text-gray-500 p-0 flex-none"
                    >{{ directory.nodes.length }} Item{{
                            directory.nodes.length !== 1 ? 's' : ''
                        }}, {{ directory.createdAt.format('MMMM Do YYYY, h:mm:ss a') }}
                    </span>
                        <span
                            class="block overflow-hidden whitespace-nowrap text-xs text-gray-500 p-0 flex-none">
                        <div class="inline-block" v-for="(tag, index) in directory.tags">
                            <div class="w-2.5 h-2.5 inline-block rounded-full flex-0 mt-1"
                                 :style="'border: 0.8px solid rgba(150, 150, 150, .3);  background-color: '+(getFsTag(tag)?getFsTag(tag).colorHex:'#FFF')"></div>
                            <div class="inline-block mr-1">{{ tag }}</div>
                        </div>
                            </span>

                    </template>
                    <template v-else>
                        <div class="flex-0">
                            <div v-for="(tag, index) in directory.tags"
                                 class="w-2.5 h-2.5 inline-block rounded-full flex-0 mt-1.5 mr-0.5"
                                 :style="'border: 0.8px solid rgba(150, 150, 150, .3);  background-color: '+(getFsTag(tag)?getFsTag(tag).colorHex:'#FFF')"></div>
                        </div>
                        <span
                            class="overflow-visible whitespace-nowrap text-xs text-gray-500 p-0 flex-0 ml-1 w-[4.5rem] text-right pr-0 mt-1"
                        >{{ directory.nodes.length }} Item{{
                                directory.nodes.length !== 1 ? 's' : ''
                            }}</span>
                        <span v-if="directory.createdAt"
                              class="overflow-visible whitespace-nowrap text-xs text-gray-500 p-0 flex-0 ml-1 w-[5.5rem] text-right pr-0 mt-1"
                        >{{ directory.createdAt.format('DD/MM/YY HH:mm') }}</span>
                    </template>

                </div>
            </div>
            <div class="block w-full m-0 pr-3 overflow-hidden max-h-20 text-right"
                 v-if="filesToBeConfirmed.length || filesBeingProcessed.length || filesToBeProcessed.length">
                {{ this.filesToBeProcessed.length + this.filesBeingProcessed.length }} remaining files to upload
                ({{ this.filesToBeConfirmed.length }} awaiting confirmation)
            </div>
            <div class="block w-full m-0 pr-3 overflow-hidden max-h-20 text-right text-red-600"
                 v-if="filesErrored.length">
                {{ this.filesErrored.length }} files failed to upload - contact support
            </div>
            <div :id="'node-preview-'+this.directory.id" class="block w-full m-0"></div>
        </vue2-dropzone>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import './fs_dropzone.css';
import {uuid} from "../../utils";
import {Fs} from '@models'
import AutoresizableInput from "../ui/AutoresizableInput";
import PageCell from "../ui/PageCell.vue";

export default {
    components: {PageCell, AutoresizableInput, vue2Dropzone},
    props: {
        filesystem: Object,
        directory: Object,
        data: Object,
        selected: Array,
        innerClass: String,
        prefs: Object,
        lastUp: false,
        lastDown: false,
        canUpload: true,
    },
    data() {
        return {
            fileDropTarget: false,
            dropzoneOptions: {
                url: 'https://a',
                clickable: false,
                timeout: 0,
                autoProcessQueue: false,
                autoQueue: false,
                parallelUploads: 25,
                useFsAccessApi: false,
                maxFilesize: 5120,
                maxFiles: null,
                previewsContainer: '#node-preview-' + this.directory.id,
                accepted: (e) => {
                },
            },
            reloadTimer: false,
            addedTimer: false,
            editingName: false,
            newName: this.directory.name,
            editable: false,
            singleClickTimeout: false,
            lastAddedCount: -1,
            lastConfirmedCount: -1,
            filesToBeProcessed: [],
            filesBeingProcessed: [],
            filesToBeConfirmed: [],
            filesErrored: [],
            collisionStrategy:null,
        }
    },
    computed: {},
    methods: {
        getFsTag(tag) {
            return this.filesystem.tags.find((t) => t.name === tag)
        },
        mousedUp(e) {
            this.editable = !e.ctrlKey && !e.shiftKey && !e.metaKey && (this.lastDown === this.lastUp)
        },
        editName(e) {
            if (!this.editable) return;
            if ((e.type === "created") || ((!this.directory.system) && this.selected.includes(this.directory))) {
                if (e) {
                    e.preventDefault()
                    e.stopPropagation()
                }
                this.singleClickTimeout = setTimeout(() => {
                    this.newName = this.directory.name
                    this.editingName = true
                    this.$nextTick(() => {
                        if (this.$refs["item-name"]) {
                            this.$refs["item-name"].$el.focus();
                        }
                    })
                }, 250)
            }
        },
        keyDown(e) {
            if (e.key === 'Escape') {
                this.newName = this.directory.name
                e.target.blur();
                this.$emit('cancelRenameNode', this.directory)
            }
        },
        updateName(e) {
            this.editingName = false
            if (this.newName === '') {
                this.newName = this.directory.name
                e.target.blur();
                this.$emit('cancelRenameNode', this.directory)
            } else if (this.newName !== this.directory.name) {
                this.$emit('renameNode', this.directory, this.newName)
            }
        },
        dragged() {
            this.$emit('draggedOver', this.directory)
        },
        draggedOut() {
            this.$emit('draggedOut', this.directory)
        },
        go() {
            this.$emit('go', this.directory)
        },
        selectDown(e) {
            if (this.id) {
                this.$emit('selectDown', this.data, e)
            }
        },
        async triggerNewFiles(files) {
            this.intentUpdateInProgress = true;
            files.forEach((i) => {
                i.id = uuid()
            })
            this.filesBeingProcessed.push(...files);
            await this.filesystem.createUploadIntent(files.map(i => {
                return {
                    id: i.id,
                    size: i.size,
                    name: i.name,
                    relativePath: i.fullPath ? i.fullPath.slice(0, 0 - i.name.length) : '/',
                    mimeType: i.type ? i.type : 'application/octet-stream'
                }
            }), this.directory.id).then((value) => {
                if (!value) {
                    console.log('Upload-Intent creation failed!')
                    files.forEach((i, key) => {
                        this.$refs['myDropzone-' + this.directory.id].$el.dropzone.removeFile(i);
                        this.filesBeingProcessed.splice(this.filesToBeProcessed.indexOf(i), 1);
                        this.filesErrored.push(1);
                    })
                    return;
                }
                files.forEach((i, key) => {
                    i.uploadTarget = value.files.find((i2) => i2.id === i.id);
                    i.uploadConfirmation = {
                        'uploadIntentId': value.id,
                        'uploadFileId': i.uploadTarget.id,
                    }
                    i.previewElement.classList.remove('hidden')
                })
                files.forEach((i, key) => {
                    this.$refs['myDropzone-' + this.directory.id].$el.dropzone.enqueueFile(i);
                })
                this.intentUpdateInProgress = false;
                this.$refs['myDropzone-' + this.directory.id].processQueue();
            })
        },
        filesAdded() {
            this.$emit('uploadingStarted', this.directory.id)
            if (this.addedTimer) {
                clearTimeout(this.addedTimer)
            }
            if (!this.intentUpdateInProgress) {
                if (this.filesToBeProcessed.length === 0) {
                    this.lastAddedCount = -1;
                    return;
//                } else if (this.filesToBeProcessed.length > 1) {
//                    this.triggerNewFiles(this.filesToBeProcessed.splice(0, 1))
                } else if (this.filesToBeProcessed.length === this.lastAddedCount) {
                    this.triggerNewFiles(this.filesToBeProcessed.splice(0, this.filesToBeProcessed.length))
                }
            }
            this.lastAddedCount = this.filesToBeProcessed.length;
            this.addedTimer = setTimeout(() => {
                this.filesAdded()
            }, 200);
        },

        async triggerConfirmation(files, collisionStrategy = null) {
            this.intentUpdateInProgress = true;
            let postProcess = async () => {
                this.intentUpdateInProgress = false;
                files.forEach((i, key) => {
                    setTimeout(() => {
                        this.$refs['myDropzone-' + this.directory.id] ? this.$refs['myDropzone-' + this.directory.id].$el.dropzone.removeFile(i) : null
                    }, 120);
                })
                if (this.filesToBeConfirmed.length + this.filesToBeProcessed.length + this.filesBeingProcessed.length === 0) {
                    this.collisionStrategy = null;
                    let newFs = await Fs.find(this.filesystem.id)
                    this.filesystem.nodes.splice(0, this.filesystem.nodes.length, ...newFs.nodes)
                    Object.assign(this.directory, newFs.getNodeById(this.directory.id))
                    this.$emit('reload')
                    this.$emit('uploadingFinished')
                }
            }
            await this.filesystem.confirmUploads(files.map(i => i.uploadConfirmation), collisionStrategy)
                .catch((e) => {
                        if (this.collisionStrategy) {
                            this.triggerConfirmation(files,this.collisionStrategy);
                        } else {
                            this.$modals.confirm({
                                title: 'Duplicate file name(s) detected',
                                paragraphs: ['One or more files being uploaded already exist in the current filesystem. Do you want to skip duplicates OR add the duplicate files?'],
                                button: 'Skip Duplicates',
                                button2: 'Add as Revisions',
                                button3: 'Add as new Files',
                                handle: async () => {
                                    this.collisionStrategy = 'skip'
                                    await this.triggerConfirmation(files, 'skip')
                                },
                                handle2: async () => {
                                    this.collisionStrategy = 'revise'
                                    await this.triggerConfirmation(files, 'revise')
                                },
                                handle3: async () => {
                                    this.collisionStrategy = 'rename'
                                    await this.triggerConfirmation(files, 'rename')
                                },
                                afterClose: async () => {
                                    this.collisionStrategy = null
                                    await postProcess()
                                }
                            })
                        }
                })
                .then(async (result) => {
                    if (!result) return;
                    postProcess();
                })
        },
        success(file) {
            this.filesBeingProcessed.splice(this.filesBeingProcessed.indexOf(file), 1);
            this.filesToBeConfirmed.push(file)
            this.filesconfirmed()
            file.previewElement.classList.add('dz-shrink')
        },
        filesconfirmed() {
            if (this.successTimer) {
                clearTimeout(this.successTimer)
            }
            if (!this.intentUpdateInProgress) {
                if (this.filesToBeConfirmed.length === 0) {
                    this.lastConfirmedCount = -1;
                    return;
                } else if (this.filesToBeConfirmed.length > 200) {
                    this.triggerConfirmation(this.filesToBeConfirmed.splice(0, 200),this.collisionStrategy)
                } else if (this.filesToBeConfirmed.length === this.lastConfirmedCount) {
                    this.triggerConfirmation(this.filesToBeConfirmed.splice(0, this.filesToBeConfirmed.length),this.collisionStrategy)
                }
            }
            this.lastConfirmedCount = this.filesToBeConfirmed.length;
            this.successTimer = setTimeout(() => {
                this.filesconfirmed()
            }, 150);
        },
    },
    mounted() {
        this.editable = false
        let that = this;
        if (this.$refs['myDropzone-' + this.directory.id]) {
            this.$refs['myDropzone-' + this.directory.id].$el.dropzone.on('addedfile', function (file) {
                if (that.canUpload !== true && (that.canUpload !== that.directory.id)) {
                    this.removeFile(file)
                    return;
                }
                file.previewElement.classList.add('hidden')
                that.filesToBeProcessed.push(file)
                that.filesAdded(this)
            });
            this.$refs['myDropzone-' + this.directory.id].$el.dropzone.on('sending', function (file, xhr, formData) {
                xhr.open('POST', file.uploadTarget.url);
                Object.entries(file.uploadTarget.inputs).forEach(entry => {
                    const [key, value] = entry;
                    formData.append(key, value);
                });
            });
        }
    }
}
</script>

<style>
.dz-drag-hover {
    background-color: rgb(219 234 254) !important;
}
</style>